// Label fonts. Glyphs for Latin, Greek, Cyrillic and map symbols ship with the app (public/fonts,
// Noto Sans, SIL OFL) so labels work offline once cached. Other ranges are fetched remotely, and
// a range that cannot be loaded resolves to an empty glyph set: MapLibre otherwise fails the
// whole vector tile, dropping lines and fills along with the labels.

import maplibregl from 'maplibre-gl';

export const GLYPHS = 'glyphs://{fontstack}/{range}';

const REMOTE = 'https://protomaps.github.io/basemaps-assets/fonts/';

/** Ranges bundled in public/fonts (see the offline pre-fetch list). */
export const BUNDLED_RANGES = ['0-255', '256-511', '512-767', '768-1023', '1024-1279', '7680-7935', '8192-8447', '9472-9727'];

let installed = false;

export function setupGlyphs(): void {
  if (installed) return;
  installed = true;
  maplibregl.addProtocol('glyphs', async (params, abort) => {
    const path = params.url.slice('glyphs://'.length);
    const range = path.split('/').pop() ?? '';
    const bases = BUNDLED_RANGES.includes(range) ? ['/fonts/', REMOTE] : [REMOTE];
    for (const base of bases) {
      try {
        const r = await fetch(`${base}${path}.pbf`, { signal: abort.signal });
        // Static hosts may answer unknown paths with the SPA's index.html.
        if (r.ok && !(r.headers.get('content-type') ?? '').includes('text/html')) return { data: await r.arrayBuffer() };
      } catch (e) {
        if (abort.signal.aborted) throw e;
      }
    }
    return { data: new ArrayBuffer(0) };
  });
}
